import { timeline } from "@/mocks/portal";

const stats = [
  { label: "已归档专题", value: "1,286", delta: "+23 本周" },
  { label: "收录内容条目", value: "34,902", delta: "+617 本周" },
  { label: "活跃检索关键词", value: "9,754", delta: "+112 今日" },
];

export default function RankFeed() {
  return (
    <section id="feed" className="scroll-mt-24 py-12 md:py-16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-4 md:px-6 lg:grid-cols-3">
        {/* 更新动态 */}
        <div className="lg:col-span-2">
          <div className="flex items-end justify-between">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                <i className="ri-refresh-line text-sm"></i>持续归档
              </div>
              <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                更新动态 · 时时追新
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                专题归档与内容查询库的实时更新，查看新收录的关键词专题。
              </p>
            </div>
          </div>

          <ul className="mt-6 divide-y divide-background-200/80 rounded-xl border border-background-200/80 bg-background-50">
            {timeline.map((it) => (
              <li key={it.title}>
                <a href="#topics" className="group flex items-center gap-3 px-4 py-3.5 md:px-5">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-500">
                    <i className="ri-arrow-up-circle-line text-lg"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                      {it.title}
                    </p>
                    <p className="mt-0.5 text-xs text-foreground-400">{it.zone}</p>
                  </div>
                  <span className="hidden rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900 sm:inline whitespace-nowrap">
                    {it.flag}
                  </span>
                  <span className="shrink-0 text-xs tabular-nums text-foreground-400 whitespace-nowrap">{it.time}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* 档案统计 */}
        <aside className="flex flex-col gap-4">
          <div className="rounded-xl border border-background-200/80 bg-background-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-database-2-line text-base"></i>
              </span>
              内容查询档案库
            </h3>
            <div className="mt-5 space-y-4">
              {stats.map((s) => (
                <div key={s.label} className="flex items-end justify-between border-b border-background-100 pb-3 last:border-0">
                  <div>
                    <p className="text-xs text-foreground-500">{s.label}</p>
                    <p className="font-heading text-2xl font-black tabular-nums text-foreground-950">{s.value}</p>
                  </div>
                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-700">
                    <i className="ri-arrow-up-line"></i>{s.delta}
                  </span>
                </div>
              ))}
            </div>
            <a
              href="#guide"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-100 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              查看使用指引 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}